import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵnextContext, ɵɵadvance, ɵɵtextInterpolate, ɵɵtemplate, ɵɵproperty, ɵɵelement, ɵɵstyleMap, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵNgOnChangesFeature, Component, Input, ViewChild, Output, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, InjectionToken } from '@angular/core';
import { NgIf, CommonModule } from '@angular/common';

/* @Injectable({
  providedIn: GoogleServiceModule
}) */
class ChartService {
    constructor() {
        console.log("GoogleChartService");
        this.google = google;
    }
    getLibrary() {
        return this.google;
    }
}
ChartService.ɵfac = function ChartService_Factory(t) { return new (t || ChartService)(); };
ChartService.ɵprov = ɵɵdefineInjectable({ token: ChartService, factory: ChartService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["chart1"];
function ChartComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 5);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r3.titlesub);
} }
function ChartComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "h5");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵtemplate(3, ChartComponent_div_0_div_3_Template, 2, 1, "div", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.title);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.titlesub);
} }
function ChartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", null, 6);
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵstyleMap(ctx_r1.chartStyle);
} }
function ChartComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, "NO DATA");
    ɵɵelementEnd();
} }
class ChartComponent {
    constructor(chartService) {
        this.chartService = chartService;
        this.id = "gchart_" + Math.floor(Math.random() * 10000);
        this.chartStyle = ""; //height: 100%;
        this.gchartComponentLoaded = false;
        this.select = new EventEmitter();
        this.noData = true;
        this.chartLib = this.chartService.getLibrary();
    }
    get data() {
        return this._data;
    }
    set data(value) {
        if (!value) {
            this.noData = true;
        }
        this._data = value;
        this.noData = false;
    }
    set extoptions(value) {
        if (value) {
        }
    }
    get extoptions() {
        return this._extoptions;
    }
    get chartoptions() {
        return this._chartoptions;
    }
    set chartoptions(value) {
        this._chartoptions = value;
        if (value) {
            this.title = value.mainTitle;
            this.titlesub = value.subtitle;
        }
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.chartLib.charts.load('current', { 'packages': ['corechart'] });
        //this.gLib.charts.setOnLoadCallback(this.drawChart); //usar con //drawChart = () => {
        //this.gLib.charts.setOnLoadCallback(this.drawChart.bind(this)); //usar con  drawChart(){
        this.chartLib.charts.setOnLoadCallback(() => {
            this.gchartComponentLoaded = true,
                this.drawChart();
        });
    }
    ngOnChanges(changes) {
        const key = 'data';
        if (changes[key]) {
            if (!this.data) {
                return;
            }
            /*       this.options = this.data.options;
                  if (!this.options) {
                    this.options = {};
                  } */
            this.data.component = this;
            //this.gLib.charts.setOnLoadCallback(this.drawChart.bind(this)); //usar con  drawChart(){
            if (this.gchartComponentLoaded) {
                this.drawChart();
            }
        }
    }
    //drawChart = () => {
    drawChart() {
        if (!this.gchartComponentLoaded) {
            return;
        }
        if (!this.data) {
            return;
        }
        try {
            if (this.chartType == "PieChart") {
                this.chart = new this.chartLib.visualization.PieChart(this.chartContainer1.nativeElement);
            }
            else if (this.chartType == "ColumnChart") {
                this.chart = new this.chartLib.visualization.ColumnChart(this.chartContainer1.nativeElement);
            }
            else if (this.chartType == "BarChart") {
                this.chart = new this.chartLib.visualization.BarChart(this.chartContainer1.nativeElement);
            }
            else if (this.chartType == "Bar") {
                this.chart = new this.chartLib.visualization.Bar(this.chartContainer1.nativeElement);
            }
            //let chart = new this.gLib.visualization.LineChart(document.getElementById('divLineChart'));
            /*     let data = new this.gLib.visualization.DataTable();
                data.addColumn('string', 'Accessories');
                data.addColumn('number', 'Quantity');
                data.addRows([
                  ['Computers', 3],
                  ['Hard Drives', 6],
                  ['Printers', 4],
                  ['Monitors', 5],
                  ['RAM', 2]
                ]); */
            // this.gLib.visualization.events.addListener(this.chart , 'select', this.selectHandler());
            const registerChartEvent = (object, eventName, callback) => {
                this.chartLib.visualization.events.addListener(object, eventName, callback);
            };
            try {
                registerChartEvent(this.chart, 'select', () => {
                    const selection = this.chart.getSelection();
                    console.log('Chart clicked : ', selection);
                    this.selectHandler();
                });
            }
            catch (exception) {
                //some charts doesn´t have this but i don´t know which
            }
            this.chart.draw(this.data, this._chartoptions);
        }
        catch (err) {
            console.log(err);
        }
    }
    selectHandler() {
        if (!this.chart) {
            return;
        }
        let selectedItem = this.chart.getSelection()[0];
        if (selectedItem) {
            let topping = this.data.getValue(selectedItem.row, 0);
            console.log('The user selected ', topping);
            this.select.emit({ selectedItem });
        }
    }
}
ChartComponent.ɵfac = function ChartComponent_Factory(t) { return new (t || ChartComponent)(ɵɵdirectiveInject(ChartService)); };
ChartComponent.ɵcmp = ɵɵdefineComponent({ type: ChartComponent, selectors: [["app-frms-chart"]], viewQuery: function ChartComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.chartContainer1 = _t.first);
    } }, inputs: { id: "id", title: "title", titlesub: "titlesub", chartStyle: "chartStyle", data: "data", extoptions: "extoptions", chartoptions: "chartoptions", chartType: "chartType" }, outputs: { select: "select" }, features: [ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [["class", "chart-title", 4, "ngIf"], [3, "style", 4, "ngIf"], [4, "ngIf"], [1, "chart-title"], ["class", "chart-title-sub", 4, "ngIf"], [1, "chart-title-sub"], ["chart1", ""]], template: function ChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ChartComponent_div_0_Template, 4, 2, "div", 0);
        ɵɵtemplate(1, ChartComponent_div_1_Template, 2, 2, "div", 1);
        ɵɵtemplate(2, ChartComponent_div_2_Template, 2, 0, "div", 2);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.title);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.noData);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.noData);
    } }, directives: [NgIf], styles: ["#divPieChart[_ngcontent-%COMP%]{height:300px;width:100%}.banner-thumbs[_ngcontent-%COMP%]{clear:both;list-style:none;margin-left:auto;margin-right:auto;padding-left:0}.banner-thumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline;margin-left:5px;margin-right:5px;vertical-align:middle}.banner-thumbs[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{cursor:pointer;margin-top:0!important;vertical-align:middle}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChartComponent, [{
        type: Component,
        args: [{
                selector: 'app-frms-chart',
                templateUrl: './chart.component.html',
                styleUrls: ['./chart.component.scss']
            }]
    }], function () { return [{ type: ChartService }]; }, { id: [{
            type: Input
        }], chartContainer1: [{
            type: ViewChild,
            args: ['chart1']
        }], title: [{
            type: Input
        }], titlesub: [{
            type: Input
        }], chartStyle: [{
            type: Input
        }], data: [{
            type: Input
        }], extoptions: [{
            type: Input
        }], chartoptions: [{
            type: Input
        }], chartType: [{
            type: Input
        }], select: [{
            type: Output
        }] }); })();

class ChartServiceModule {
}
ChartServiceModule.ɵmod = ɵɵdefineNgModule({ type: ChartServiceModule });
ChartServiceModule.ɵinj = ɵɵdefineInjector({ factory: function ChartServiceModule_Factory(t) { return new (t || ChartServiceModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ChartServiceModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChartServiceModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();

const CHARTS_CONFIG_TOKEN = new InjectionToken('CHARTS_CONFIG_TOKEN');

//import { TableChartComponent } from './table-chart/table-chart.component';
class ChartModule {
    static forRoot(config = {}) {
        return {
            ngModule: ChartModule,
            providers: [{ provide: CHARTS_CONFIG_TOKEN, useValue: config }]
        };
    }
}
ChartModule.ɵmod = ɵɵdefineNgModule({ type: ChartModule });
ChartModule.ɵinj = ɵɵdefineInjector({ factory: function ChartModule_Factory(t) { return new (t || ChartModule)(); }, providers: [], imports: [[
            CommonModule,
            ChartServiceModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ChartModule, { declarations: [ChartComponent], imports: [CommonModule,
        ChartServiceModule], exports: [ChartComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ChartModule, [{
        type: NgModule,
        args: [{
                declarations: [ChartComponent],
                imports: [
                    CommonModule,
                    ChartServiceModule
                ],
                exports: [
                    ChartComponent
                ],
                providers: []
            }]
    }], null, null); })();

/*
         var options = {
           title: 'GDP of selected countries, in US $millions',
           width: 500,
           height: 300,
           legend: 'none',
           bar: {groupWidth: '95%'},
           vAxis: { gridlines: { count: 4 } }
         };
 */
class ChartOptions {
    constructor() {
        this.legend = true;
    }
}

/*
 * Public API Surface of fr-chart
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChartComponent, ChartModule, ChartOptions, ChartService, ChartServiceModule };
//# sourceMappingURL=fr-chart.js.map
